import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    hr: {
      color: '#FFF',
      margin: '40px 0',

      [media.desktop]: {
        display: 'none',
      },
    },

    trackSessionsSection: {
      maxWidth: 1378,
      margin: '0 auto',
      width: '100%',
    },

    trackSessions: {
      display: 'flex',
      flexFlow: 'column wrap',
      width: '100%',

      [children('article')]: {
        borderBottom: '1px solid #707070',
      },

      [media.desktop]: {
        flexFlow: 'row wrap',

        [children('article')]: {
          width: '50%',
        },

        [children('article') + ':nth-of-type(even)']: {
          borderLeft: '1px solid #707070',
        },
      },
    },

    h2: {
      color: '#FFF',
      textAlign: 'center',
      margin: '30px 0',

      [media.desktop]: {
        fontSize: 40,
      },
    },

    trackSessionsCategories: {
      display: 'flex',
      color: '#FFF',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontWeight: 'bold',
      borderBottom: '5px solid #E60012',
      fontSize: 14,

      [children('div') + ':not(:last-child)']: {
        marginRight: 3,
      },

      [media.tablet]: {
        fontSize: 16,
      },

      [media.desktop]: {
        fontSize: 30,
      },
    },

    trackSessionCategory: {
      cursor: 'pointer',
      background: palette.grey,
      padding: '20px 0',
      textAlign: 'center',
      width: '33%',
      flexGrow: 1,
      alignSelf: 'stretch',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',

      ':hover': {
        background: palette.red,
      },

      [children('span')]: {
        alignSelf: 'center',
      },

      [media.desktop]: {
        padding: '20px 25px',
      },
    },

    isActiveCategory: {
      background: palette.red,
    },
  });
};
